import { TextField, styled } from "@mui/material";

export const CssTextField = styled(TextField, {
  shouldForwardProp: (prop) => !["helper"].includes(prop),
})(({ theme, helper }) => ({
  width: "100%",

  "& .MuiOutlinedInput-root": {
    backgroundColor: "#FFF",
    borderRadius: "22px",
    minHeight: 56,
    transition: ".25s",

    "& fieldset": {
      borderColor: helper ? "#D32F2F" : "#E8E8E8",
      borderWidth: "1px",
      borderRadius: "22px",
    },

    "&:hover fieldset": {
      borderColor: helper ? "#D32F2F" : "#D0D0D0",
    },

    "&.Mui-focused fieldset": {
      borderColor: helper ? "#D32F2F" : "#2349D0",
      borderWidth: "1.5px",
    },

    "& input": {
      padding: "16px 18px",
      fontFamily: "Plus Jakarta Sans",
      fontSize: 16,
      color: "#333",
    },

    "& textarea": {
      fontFamily: "Plus Jakarta Sans",
      fontSize: 16,
      color: "#333",
      padding: "2px 0",
    },

    "& input::placeholder": {
      color: "#BDBDBD",
      opacity: 1,
    },

    "& textarea::placeholder": {
      color: "#BDBDBD",
      opacity: 1,
    },
  },

  "& .MuiInputLabel-root": {
    color: "#A8A8A8",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 16,
    transform: "translate(18px, 16px) scale(1)",
  },

  "& .MuiInputLabel-root.Mui-focused": {
    color: helper ? "#D32F2F" : "#2349D0",
  },

  "& .MuiInputBase-input:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0 100px white inset",
    WebkitTextFillColor: "#333",
    borderRadius: "22px",
  },
  "& .MuiOutlinedInput-root.MuiInputBase-multiline": {
    alignItems: "flex-start",
    paddingTop: "14px",
    borderRadius: "22px",
  },
  // Cuando el label se mueve arriba
  "& .MuiInputLabel-shrink": {
    transform: "translate(18px, -9px) scale(0.85)",
    background: "#FFF",
    padding: "0 6px",
  },
}));
